<h1 class="text-center mt-2">Gestion des fichiers</h1>
<div class="example-container">
  <div class="container-row top-field" style="margin-left: 55px">
    <div class="btn1">
      <button (click)="addFile()" id="btn-add-concession" class="mr-5 btn btn-dark">
        <mat-icon>add_circle</mat-icon> Fichier
      </button>
    </div>
  </div>
  <table mat-table [dataSource]="dataSource" class="user-table mat-elevation-z8">

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef> Version </th>
      <td mat-cell *matCellDef="let element"> {{element.type}} </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nom </th>
      <td mat-cell *matCellDef="let element"> {{element.name}} </td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef> Date </th>
      <td mat-cell *matCellDef="let element"> {{element.date}} </td>
    </ng-container>

<!--    <ng-container matColumnDef="download">-->
<!--      <th mat-header-cell *matHeaderCellDef></th>-->
<!--      <td mat-cell *matCellDef="let element"><mat-icon (click)="downloadFile(element.id, element.type)" class="pointer">download</mat-icon></td>-->
<!--    </ng-container>-->

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element"><mat-icon (click)="deleteFile(element.id, element.type)" class="pointer">delete</mat-icon></td>
    </ng-container>

<!--    <ng-container matColumnDef="active">-->
<!--      <th mat-header-cell *matHeaderCellDef > Actif </th>-->
<!--      <td mat-cell *matCellDef="let element">-->
<!--        <mat-icon *ngIf="element.active">check</mat-icon>-->
<!--        <mat-icon *ngIf="!element.active">close</mat-icon>-->
<!--      </td>-->
<!--    </ng-container>-->

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="getPageSizeOptions()"
                 (click)="displayPaginatorAllOption()"
                 (page)="pageChange()"
                 showFirstLastButtons
                 aria-label="Sélectionner la page">
  </mat-paginator>
</div>
